module.exports = __webpack_public_path__ + "assets/htu-8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-8.jpg
// module id = 1195
// module chunks = 7